import ballstonImg from "../images/afro-solar/international-projects/ball-stone-usa.webp";
import bundeImg from "../images/afro-solar/international-projects/bunde-netherlands.webp";
import neesImg from "../images/afro-solar/international-projects/nees-park-denmark.webp";
import oregonImg from "../images/afro-solar/international-projects/oreon-usa.webp";

const projects = [
  {
    img: bundeImg,
    name: "Bunde, Netherlands​",
  },
  {
    img: neesImg,
    name: "Nees Park, Denmark​​",
  },
  {
    img: ballstonImg,
    name: "Ballston, USA​​",
  },
  {
    img: oregonImg,
    name: "Oregon, USA​​",
  },
];

const InternationalProjects = () => {
  return (
    // <div className="py-5 international-projects-container">
    <div className="py-5">
      <h1 className="fs-56 lh-64 text-center gilroy-bold pb-5">
        International Projects
      </h1>
      <div className="container-fluid">
        <div className="ms-13 me-13">
          <div className="row align-items-center">
            {/* <div className="col-12 col-md-6 p-4">
              <h2 className="fs-56 gilroy-bold text-white">
                Examples of{" "}
                <span className="text-orange-ryb d-block">
                  International Projects :
                </span>
              </h2>
            </div> */}
            <div className="col-12 bg-white p-4 rounded">
              <div className="row g-4">
                {projects.map((project) => (
                  <div
                    key={project.name}
                    className="col-12 col-sm-6 col-md-6 pb-5"
                  >
                    <img
                      src={project.img}
                      loading="lazy"
                      alt={project.name}
                      className="img-fluid rounded w-100"
                    />
                    <h3 className="fs-18 gilroy-bold mt-2 ">{project.name}</h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternationalProjects;
